<div class="searchBase" [class.ios]="utils.ios()" [class.android]="utils.android()">

  @if (flags.showSettings && user != null) {
    <app-search-settings></app-search-settings>
  }
  <!-- <app-search-settings *ngIf="user != null"></app-search-settings> -->

  <div class="searchBar" [class.ios]="utils.ios()" [class.android]="utils.android()">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" (keyup.enter)="onSubmit();$event.target.blur()">
      <div fxlayout="row" class="searchCntent">
        <div  fxFlex="50px">
          <button class="dates" mat-button matTooltip="Events" (click)="display='posts';searchStr=null;utils.sound()" routerLink="/posts" onclick="window.scrollTo(0,0)" [disabled]="router.url == '/search' || router.url.includes('/posts') || router.url.includes('/events')"><mat-icon>date_range</mat-icon></button>
        </div>
        <div  fxFlex="50px">
          <button class="activities" mat-button matTooltip="Activities" (click)="display='activities';searchStr=null;utils.sound()" routerLink="/activities" onclick="window.scrollTo(0,0)" [disabled]="router.url.includes('/activities')"><mat-icon>accessibility_new</mat-icon></button>
        </div>
        <div fxFlex="50px">
          <button class="members" mat-button matTooltip="Members" (click)="display='users';searchStr=null;utils.sound()" routerLink="/members" onclick="window.scrollTo(0,0)" [disabled]="router.url.includes('/members')"><mat-icon>face</mat-icon></button>
        </div>
        <div fxFlex class="searchStr">
          <mat-form-field>
            <input matInput placeholder="Search" (click)="clearSearchInput()" (keydown)="onEnter($event)" (change)="activateBtn($event)" type="text" class="form-control" formControlName="searchStr" [ngClass]="{ 'is-invalid': flags.sfe && f.searchStr.invalid }" autocomplete="search" id="autofill-search">
            @if (f.searchStr.hasError('serverError')) {
              <mat-error>
                <small>{{f.searchStr.errors.serverError}}</small>
              </mat-error>
            }
            @if (f.searchStr.hasError('searchStr')) {
              <mat-error>
                <small>Invalid Input</small>
              </mat-error>
            }
          </mat-form-field>
        </div>
        @if (user != null) {
          <div fxFlex="30px">
            @if (!router.url.includes('/activities')) {
              <button mat-button matTooltip="Settings" class="settingsBtn" (click)="flags.showSettings=!flags.showSettings" onclick="window.scrollTo(0,0)"><mat-icon>settings</mat-icon></button>
            }
          </div>
        }
        <div  fxFlex="16">
          <button mat-button type="submit" class="searchBtn" (click)="onSubmit()" [class.btnReady2]="f?.searchStr?.value?.length > 0" [disabled]="f?.searchStr?.value?.length == 0"><mat-icon>search</mat-icon></button>
        </div>
      </div>
    </form>
  </div>


  @if (router.url.includes('/members') || (searchStr != null && searchStr != '')) {
    <app-search-users (resultCount)="flags.userCount = $event" [searchStr]="searchStr"></app-search-users>
  }
  @if (router.url.includes('/activities') || (searchStr != null && searchStr != '')) {
    <app-search-activities (resultCount)="flags.activityCount = $event" [searchStr]="searchStr"></app-search-activities>
  }
  @if (router.url == '/search' || router.url.includes('/posts') || router.url.includes('/events') || (searchStr != null && searchStr != '')) {
    <app-search-posts (resultCount)="flags.postCount = $event" [searchStr]="searchStr"></app-search-posts>
  }



  @if (flags.userCount == 0 && flags.activityCount == 0 && flags.postCount == 0) {
    <div class="noResults">
      <h2><mat-icon>sentiment_neutral</mat-icon></h2>
      <h2>No Results Found</h2>
      <br /><br />
      @if (searchStr) {
        <button mat-button routerLink="/search" (click)="searchStr=null;"><mat-icon>arrow_back</mat-icon> Back</button>
      }
      <br /><br />
    </div>
  }
  <br clear="all" />
</div>